import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface SitterBlockParent {
  id?: number;
  sitterId: number;
  parentId: number;
}

const URL = '/v2/sitter-block-parent';

class SitterBlockParentService {
  static create(
    data: Omit<SitterBlockParent, 'id'>,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SitterBlockParent>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SitterBlockParentService };
